var LUCIDE_ICON_PATHS = {
  alignLeft: [
    '<path d="M15 12H3"></path>',
    '<path d="M17 18H3"></path>',
    '<path d="M21 6H3"></path>'
  ],
  alignCenter: [
    '<path d="M17 12H7"></path>',
    '<path d="M19 18H5"></path>',
    '<path d="M21 6H3"></path>'
  ],
  alignRight: [
    '<path d="M21 12H9"></path>',
    '<path d="M21 18H7"></path>',
    '<path d="M21 6H3"></path>'
  ],
  arrowRight: [
    '<path d="M5 12h14"></path>',
    '<path d="m12 5 7 7-7 7"></path>'
  ],
  badgeInfo: [
    '<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>',
    '<line x1="12" x2="12" y1="16" y2="12"></line>',
    '<line x1="12" x2="12.01" y1="8" y2="8"></line>'
  ],
  bell: [
    '<path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"></path>',
    '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path>'
  ],
  blocks: [
    '<rect width="7" height="7" x="14" y="3" rx="1"></rect>',
    '<path d="M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3"></path>'
  ],
  bot: [
    '<path d="M12 8V4H8"></path>',
    '<rect width="16" height="12" x="4" y="8" rx="2"></rect>',
    '<path d="M2 14h2"></path>',
    '<path d="M20 14h2"></path>',
    '<path d="M15 13v2"></path>',
    '<path d="M9 13v2"></path>'
  ],
  building2: [
    '<path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>',
    '<path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>',
    '<path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>',
    '<path d="M10 6h4"></path>',
    '<path d="M10 10h4"></path>',
    '<path d="M10 14h4"></path>',
    '<path d="M10 18h4"></path>'
  ],
  calendarCheck: [
    '<path d="M8 2v4"></path>',
    '<path d="M16 2v4"></path>',
    '<rect width="18" height="18" x="3" y="4" rx="2"></rect>',
    '<path d="M3 10h18"></path>',
    '<path d="m9 16 2 2 4-4"></path>'
  ],
  bookOpen: [
    '<path d="M12 7v14"></path>',
    '<path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>'
  ],
  chevronRight: [
    '<path d="m9 18 6-6-6-6"></path>'
  ],
  chevronDown: [
    '<path d="m6 9 6 6 6-6"></path>'
  ],
  chevronLeft: [
    '<path d="m15 18-6-6 6-6"></path>'
  ],
  check: [
    '<path d="M20 6 9 17l-5-5"></path>'
  ],
  bold: [
    '<path d="M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8"></path>'
  ],
  clipboardCheck: [
    '<rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>',
    '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>',
    '<path d="m9 14 2 2 4-4"></path>'
  ],
  clipboard: [
    '<rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>',
    '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>'
  ],
  code: [
    '<polyline points="16 18 22 12 16 6"></polyline>',
    '<polyline points="8 6 2 12 8 18"></polyline>'
  ],
  copy: [
    '<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>',
    '<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>'
  ],
  cornerDownRight: [
    '<polyline points="15 10 20 15 15 20"></polyline>',
    '<path d="M4 4v7a4 4 0 0 0 4 4h12"></path>'
  ],
  feather: [
    '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path>',
    '<line x1="16" x2="2" y1="8" y2="22"></line>',
    '<line x1="17.5" x2="9" y1="15" y2="15"></line>'
  ],
  fileText: [
    '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>',
    '<path d="M14 2v4a2 2 0 0 0 2 2h4"></path>',
    '<path d="M10 9H8"></path>',
    '<path d="M16 13H8"></path>',
    '<path d="M16 17H8"></path>'
  ],
  gitBranch: [
    '<line x1="6" x2="6" y1="3" y2="15"></line>',
    '<circle cx="18" cy="6" r="3"></circle>',
    '<circle cx="6" cy="18" r="3"></circle>',
    '<path d="M18 9a9 9 0 0 1-9 9"></path>'
  ],
  handshake: [
    '<path d="m11 17 2 2a1 1 0 1 0 3-3"></path>',
    '<path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"></path>',
    '<path d="m21 3 1 11h-2"></path>',
    '<path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path>',
    '<path d="M3 4h8"></path>'
  ],
  listOrdered: [
    '<line x1="10" x2="21" y1="6" y2="6"></line>',
    '<line x1="10" x2="21" y1="12" y2="12"></line>',
    '<line x1="10" x2="21" y1="18" y2="18"></line>',
    '<path d="M4 6h1v4"></path>',
    '<path d="M4 10h2"></path>',
    '<path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"></path>'
  ],
  list: [
    '<path d="M3 12h.01"></path>',
    '<path d="M3 18h.01"></path>',
    '<path d="M3 6h.01"></path>',
    '<path d="M8 12h13"></path>',
    '<path d="M8 18h13"></path>',
    '<path d="M8 6h13"></path>'
  ],
  image: [
    '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>',
    '<circle cx="9" cy="9" r="2"></circle>',
    '<path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>'
  ],
  italic: [
    '<line x1="19" x2="10" y1="4" y2="4"></line>',
    '<line x1="14" x2="5" y1="20" y2="20"></line>',
    '<line x1="15" x2="9" y1="4" y2="20"></line>'
  ],
  link: [
    '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>',
    '<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>'
  ],
  link2Off: [
    '<path d="M9 17H7A5 5 0 0 1 7 7h2"></path>',
    '<path d="M15 7h2a5 5 0 0 1 4 8"></path>',
    '<line x1="8" x2="12" y1="12" y2="12"></line>',
    '<line x1="2" x2="22" y1="2" y2="22"></line>'
  ],
  maximize: [
    '<path d="M15 3h6v6"></path>',
    '<path d="m21 3-7 7"></path>',
    '<path d="M9 21H3v-6"></path>',
    '<path d="m3 21 7-7"></path>'
  ],
  messageCircle: [
    '<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>'
  ],
  logOut: [
    '<path d="m16 17 5-5-5-5"></path>',
    '<path d="M21 12H9"></path>',
    '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>'
  ],
  mic: [
    '<path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"></path>',
    '<path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>',
    '<path d="M12 19v3"></path>'
  ],
  paperclip: [
    '<path d="m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551"></path>'
  ],
  pencil: [
    '<path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path>',
    '<path d="m15 5 4 4"></path>'
  ],
  plus: [
    '<path d="M5 12h14"></path>',
    '<path d="M12 5v14"></path>'
  ],
  refreshCcw: [
    '<path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>',
    '<path d="M3 3v5h5"></path>',
    '<path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"></path>',
    '<path d="M16 16h5v5"></path>'
  ],
  removeFormatting: [
    '<path d="M4 7V4h16v3"></path>',
    '<path d="M5 20h6"></path>',
    '<path d="M13 4 8 20"></path>',
    '<path d="m15 15 5 5"></path>',
    '<path d="m20 15-5 5"></path>'
  ],
  shieldAlert: [
    '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>',
    '<path d="M12 8v4"></path>',
    '<path d="M12 16h.01"></path>'
  ],
  search: [
    '<circle cx="11" cy="11" r="8"></circle>',
    '<path d="m21 21-4.3-4.3"></path>'
  ],
  circleCheck: [
    '<circle cx="12" cy="12" r="10"></circle>',
    '<path d="m9 12 2 2 4-4"></path>'
  ],
  send: [
    '<path d="m22 2-7 20-4-9-9-4Z"></path>',
    '<path d="M22 2 11 13"></path>'
  ],
  settings: [
    '<path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>',
    '<circle cx="12" cy="12" r="3"></circle>'
  ],
  sparkles: [
    '<path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z"></path>',
    '<path d="M5 3v4"></path>',
    '<path d="M19 17v4"></path>',
    '<path d="M3 5h4"></path>',
    '<path d="M17 19h4"></path>'
  ],
  target: [
    '<circle cx="12" cy="12" r="10"></circle>',
    '<circle cx="12" cy="12" r="6"></circle>',
    '<circle cx="12" cy="12" r="2"></circle>'
  ],
  thumbsDown: [
    '<path d="M17 14V2"></path>',
    '<path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"></path>'
  ],
  thumbsUp: [
    '<path d="M7 10v12"></path>',
    '<path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"></path>'
  ],
  trendingUp: [
    '<polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>',
    '<polyline points="16 7 22 7 22 13"></polyline>'
  ],
  trash2: [
    '<path d="M10 11v6"></path>',
    '<path d="M14 11v6"></path>',
    '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path>',
    '<path d="M3 6h18"></path>',
    '<path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>'
  ],
  userRound: [
    '<circle cx="12" cy="8" r="5"></circle>',
    '<path d="M20 21a8 8 0 0 0-16 0"></path>'
  ],
  video: [
    '<path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.934a.5.5 0 0 0-.777-.416L16 11"></path>',
    '<rect x="2" y="6" width="14" height="12" rx="2"></rect>'
  ],
  triangleAlert: [
    '<path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path>',
    '<path d="M12 9v4"></path>',
    '<path d="M12 17h.01"></path>'
  ],
  radar: [
    '<path d="M13.4 10.6 19 5"></path>',
    '<path d="M5 19h14"></path>',
    '<path d="M14 19a7 7 0 1 0-14 0"></path>',
    '<path d="M9 19a2 2 0 1 0-4 0"></path>'
  ],
  x: [
    '<path d="M18 6 6 18"></path>',
    '<path d="m6 6 12 12"></path>'
  ],
  zap: [
    '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>'
  ]
}

function renderLucideIcon(name, attrs) {
  var paths = LUCIDE_ICON_PATHS[toIconKey(name)]
  if (!paths) return ''
  attrs = attrs || {}
  var size = attrs.size || 20
  var className = attrs.class ? ' class="' + attrs.class + '"' : ''
  var ariaHidden = attrs['aria-hidden'] === false ? '' : ' aria-hidden="true"'

  return '<svg' + className + ariaHidden + ' viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" focusable="false">' +
    paths.join('') +
    '</svg>'
}

function toIconKey(name) {
  return String(name || '').replace(/-([a-z])/g, function (_match, letter) {
    return letter.toUpperCase()
  })
}

export { renderLucideIcon }
